import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { BsTelegram } from "react-icons/bs";
import { IoIosArrowUp } from "react-icons/io";
import { Link } from "react-scroll";
import { useState, useEffect, useRef } from 'react';
import Cookies from "js-cookie";

function Footer() {
    const [showBanner, setShowBanner] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => {
        const isClosed = Cookies.get('event-banner-closed');
        const isOpened = Cookies.get('event-banner-opened');

        if (isClosed || isOpened) return;

        timerRef.current = setTimeout(() => {
            setShowBanner(true);
            Cookies.set('event-banner-opened', '1', { expires: 30 });
        }, 30000);

        return () => clearTimeout(timerRef.current);
    }, []);

    const closeBanner = () => {
        Cookies.set('event-banner-closed', '1', { expires: 30 });
        setShowBanner(false);
    };

    const buyTicket = () => {
        const formatsSection = document.getElementById('formats');

        if (formatsSection) {
            formatsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }

        closeBanner();
    };

    return (
        <>
            <footer className="relative bg-[#C8D2DB] text-[#010A13] py-20 md:py-9 xl:pt-16">
                <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 p-4 relative z-20">
                    <div>
                        <h4 className="text-xl uppercase mb-6">Участь і партнерство</h4>
                        <div className="flex flex-col gap-3">
                            <p>Iрина</p>
                            <a href="tel:+380674084524" className="phone_partner_clk hover:text-[#F4F0EA] transition-colors duration-300">
                                +38 (067) 408 45 24
                            </a>
                            <a href="mailto:i.pyrog@ekonomika.ua" className="phone_partner_clk_1 hover:text-[#F4F0EA] transition-colors duration-300">
                                i.pyrog@ekonomika.ua
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-xl uppercase mb-6">Питання щодо участі</h4>
                        <div className="flex flex-col gap-3 mb-7">
                            <p>Яна</p>
                            <a href="tel:+380672230179" className="phone_partner_clk hover:text-[#F4F0EA] transition-colors duration-300">
                                +38 (067) 223 01 79
                            </a>
                            <a href="mailto:tickets@ekonomika.ua" className="phone_partner_clk_1 hover:text-[#F4F0EA] transition-colors duration-300">
                                tickets@ekonomika.ua
                            </a>
                        </div>
                        <div className="flex flex-col gap-3">
                            <p>Світлана</p>
                            <a href="tel:+30968369409" className="phone_partner_clk hover:text-[#F4F0EA] transition-colors duration-300">
                                +38 096 836 94 09
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-xl uppercase mb-6">Реклама</h4>
                        <div className="flex flex-col gap-3">
                            <p>Ірина</p>
                            <a href="tel:+380672358382" className="phone_partner_clk hover:text-[#F4F0EA] transition-colors duration-300">
                                +38 (067) 235-83-82
                            </a>
                            <a href="mailto:i.skorohod@ekonomika.ua" className="phone_partner_clk_1 hover:text-[#F4F0EA] transition-colors duration-300">
                                i.skorohod@ekonomika.ua
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-xl uppercase mb-6">Слідкуйте за анонсами</h4>
                        <div className="flex gap-6 mb-9">
                            <a href="https://www.facebook.com/delo.ua/" className="text-3xl hover:text-[#F4F0EA] transition-colors duration-300" target="_blank"><FaFacebook/></a>
                            <a href="https://www.instagram.com/delo.ua/" className="text-3xl hover:text-[#F4F0EA] transition-colors duration-300" target="_blank"><RiInstagramFill/></a>
                            <a href="https://t.me/delo_ua" className="text-3xl hover:text-[#F4F0EA] transition-colors duration-300" target="_blank"><BsTelegram/></a>
                        </div>

                        <p className="text-xl mb-[16px] hover:text-[#F4F0EA] transition-colors duration-300">
                            <a href="/privacy-policy">Політика Приватності</a>
                        </p>
                        <p className="text-xl hover:text-[#F4F0EA] transition-colors duration-300">
                            <a href="/offer">Оферта</a>
                        </p>
                    </div>
                </div>
            </footer>

            <div className="fixed bottom-4 right-4 text-black bg-[#F4F0EA] hover:bg-[#FED949] border border-[#F4F0EA] p-2 rounded-[6px] z-50 cursor-pointer">
                <Link to="top" smooth={true} offset={-70} duration={500}>
                    <IoIosArrowUp />
                </Link>
            </div>

            {showBanner && (
                <div className="fixed bottom-5 right-5 bg-white shadow-2xl overflow-hidden border border-[#E5E5E5] z-50 max-w-[650px]">
                    <button onClick={closeBanner} className="absolute top-3 right-3 text-[#010A13] hover:text-[#FED949] transition" aria-label="Закрити">✕</button>

                    <div className="p-6">
                        <h3 className="text-[22px] font-bold mb-3">
                            Ваш квиток не згорить через зовнішні обставини
                        </h3>

                        <p className="text-[15px] mb-5 text-[#505050]">
                            Ми розуміємо непередбачуваність часу. <strong>HRWS відбудеться у безпечному місці з укриттям.</strong>
                        </p>

                        <p className="text-[15px] mb-5 text-[#505050]">
                            А якщо зовнішні обставини завадять вам бути з нами 8 липня, ви зможете відвідати будь-яку іншу подію Ekonomika+ до кінця 2026 року.
                        </p>

                        <div className="flex gap-3">
                            <button onClick={buyTicket} className="flex-1 bg-[#FED949] hover:bg-[#E8B500] text-black font-semibold py-3 px-4 transition">
                                Купити
                            </button>

                            <button onClick={closeBanner} className="flex-1 border border-[#DADADA] hover:bg-[#F4F0EA] py-3 px-4 rounded-[6px] transition">
                                Закрити
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Footer;